import './style/index.js';

import _Slider from './slider';

export type { SliderProps } from './slider';
export * from './type';

export const Slider = _Slider;
export default Slider;
